import { AppInfo } from "../Application.js";
import { DiamondButton } from "../display/DiamondButton.js";
import { LoginRole } from "../display/Login.js";
import { Stage } from "../display/Stage.js";

export interface SelectorAppOptions {
    element: HTMLDivElement;
    appInfos: AppInfo[];
    role: LoginRole;
}

export class SelectorApp {

    private _element: HTMLDivElement;
    private _stage: Stage;
    private _options: SelectorAppOptions;

    constructor(options: SelectorAppOptions) {

        this._options = options;
        this._element = options.element;

        this.init();
    }

    private async init() {
        this._stage = new Stage({
            element: this._element,
            className: "selector-app",
            layout: "responsive"
        });

        try {

            var logout = new DiamondButton({
                container: this._stage.content,
                className: "selector-app__logout",
                label: "Logout",
                shape: "box",
                filled: false,
                onClick: () => {
                    localStorage.removeItem("login-hash");
                    window.open(e5.Url.params.setAll({}), "_self");
                }
            });

            var container = document.createElement("div");
            container.classList.add("selector-app__content");
            for (let appInfo of this._options.appInfos) {
                if (appInfo.showInSelector === false) {
                    continue;
                }

                if (appInfo.roles !== "*"
                    && appInfo.roles.indexOf(this._options.role) === -1) {
                    continue;
                }

                var a = document.createElement("a");
                a.classList.add("selector-app__link");
                a.href = e5.Url.params.set("app", appInfo.key);
                a.innerHTML = `
            <span class="selector-app__link-icon ${appInfo.icon || "e5 icon-682"}"></span>
            <span class="selector-app__link-title">${e5.Text.escapeHtml(appInfo.name)}</span>
            `;

                container.appendChild(a);
            }
            this._stage.content.appendChild(container);

        } catch (error) {
            var err = error as Error;
            console.error(error);
            this._stage.preloader.showError(err?.message || "Es ist ein Unbekannter Fehler aufgetreten.");
            return;
        }

        this._stage.preloader.hide();
    }
}